import {Component, OnInit} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { SearchCriteria } from '../models/search-criteria';
import { SearchResult } from '../models/search-result';
import * as fromRoot from '../reducers';
import * as fromDocument from '../../document/reducers';
import * as documentActions from '../../document/actions/document';
import * as fromApp from '../../../app.reducer';
import { KvItem } from 'app/modules/core/models/kv-item';
import * as actions from '../actions/search';
import { DocumentMaster } from 'app/modules/document/models/document-master';

@Component({
  selector: 'app-start-page',
  template: `<div>
    <glenn-dale-results
      [results]="results$ | async"
      [loading]="loading$ | async"
      (downloadFile)="download($event)"></glenn-dale-results>
  </div>
`
})
export class GlenDaleComponent {
  results$: Observable<DocumentMaster[]>;
  loading$: Observable<boolean>;
  
  constructor(private store: Store<fromRoot.State>,
    private appStore: Store<fromApp.State>) {
    this.results$ = this.store.select(fromRoot.getGlennDale);
    this.loading$ = this.store.select(fromRoot.getSearchLoading);
    
    this.store.dispatch(new actions.LoadGlennDaleDocumentsAction());
  }

  download(e: KvItem) {
    this.store.dispatch(new actions.DownloadFileAction(e));
  }
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/containers/glen-dale.ts